import Grid from "@mui/material/Grid";
import { useStore } from "@tanstack/react-form";
import type React from "react";
import { useMemo } from "react";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";

import { useGetApiAssetscategoryattributesList } from "../../../api/rest/generated/assets-category-attributes/assets-category-attributes.ts";
import { Price } from "./attribute-filter/Price.tsx";
import { NajetoDo } from "./attribute-filter/NajetoDo.tsx";
import { Palivo } from "./attribute-filter/Palivo.tsx";
import { Prevodovka } from "./attribute-filter/Prevodovka.tsx";
import { RokVyrobyOd } from "./attribute-filter/RokVyrobyOd.tsx";
import { RokVyrobyDo } from "./attribute-filter/RokVyrobyDo.tsx";
import { RokUvedeniDoProvozuOd } from "./attribute-filter/RokUvedeniDoProvozuOd.tsx"
import { RokUvedeniDoProvozuDo } from "./attribute-filter/RokUvedeniDoProvozuDo.tsx"
import type { AttributeFilterProps } from "./attribute-filter/types.ts";
import { Znacka } from "./attribute-filter/Znacka.tsx";
import type {
  AssetAttributeListItem
} from "../../../api/rest/generated/aPIForPublicPartOfApplicationInzerceNemovitéhoMajetku.schemas.ts";

export const AttributeFilter: React.FC<AttributeFilterProps> = ({
  overviewForm,
  allAds,
}) => {
  const attributes = useGetApiAssetscategoryattributesList();

  const categoryId = useStore(
    overviewForm.store,
    (select) => select.values?.AssetsCategoryId,
  );

  const attributesList: AssetAttributeListItem[] = useMemo(() => attributes?.data?.data ?? [], [attributes?.data?.data]);

  const allowedCategories = [1,2];
  if(!allowedCategories.includes(categoryId)) {
    return null;
  }

  return (
    <ErrorBoundary fallback={null}>
      <Suspense fallback={null}>
        <Grid spacing={3} container={true}>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Znacka
              attributesList={attributesList}
              overviewForm={overviewForm}
              allAds={allAds}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <RokUvedeniDoProvozuOd
              attributesList={attributesList}
              overviewForm={overviewForm}
              allAds={allAds}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <RokUvedeniDoProvozuDo
              attributesList={attributesList}
              overviewForm={overviewForm}
              allAds={allAds}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Palivo
              attributesList={attributesList}
              overviewForm={overviewForm}
              allAds={allAds}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <NajetoDo
              attributesList={attributesList}
              overviewForm={overviewForm}
              allAds={allAds}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Price
              overviewForm={overviewForm}
              allAds={allAds}
            />
          </Grid>
        </Grid>
      </Suspense>
    </ErrorBoundary>
  );
};
